import React from 'react';
import { Button } from './ui/button';

const Navbar = ({ onRegisterClick }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0B] border-b border-white/10">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-[#F5A623] to-[#F7B731] rounded-lg flex items-center justify-center text-black font-bold text-xl">
              SW
            </div>
            <span className="text-white text-xl font-semibold">Signature of Wealth</span>
          </div>

          <div className="hidden md:flex items-center">
            <Button 
              onClick={onRegisterClick}
              className="bg-[#F5A623] hover:bg-[#E59400] text-black font-semibold px-6"
            >
              Join Free Webinar Now
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;